<div class="d-flex flex-column min-vh-100">
  <app-header></app-header>
  <main [@siRouterFadeAnimation]="getRouteAnimation(route)" class="flex-fill">
    <div [style]="greyOut">
      <router-outlet #route="outlet"></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
</div>
